import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

const index = () => {
  return (
    <Wrapper>
      <div className="section section-center">
        <div className="services-center">
          <div className="img-wrapper">
            <StaticImage
              className="img"
              src="../../assets/images/chaica.png"
              layout="constrained"
              alt="puelo"
              placeholder="blurred"
            />
          </div>
          <article>
            <h4>El perfecto mix entre comodidad y confort</h4>
            <ul>
              <li>
                A tan solo 25 minutos de Pto Montt en Chaica, KM 34, Carretera
                Austral.
              </li>
              <li>A solo 5 minutos en auto del parque Alerce Andino.</li>
              <li>A solo 30 metros de la playa. </li>
              <li>
                Totalmente equipada, acceso independiente con estacionamiento,
                baño, cocina, dos habitaciones,parrilla, hamaca y terraza
                techada con tinaja.
              </li>
            </ul>
            <div className="btn-center">
              <Link to="/cabaña" className="btn">
                Ver más
              </Link>
            </div>
          </article>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  background: #fbf1ea;
  .services-center {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
  }
  .img-wrapper {
    max-width: 600px;
    margin-bottom: 50px;
  }
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  article {
    max-width: 500px;
    .btn-center {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  @media screen and (min-width: 992px) {
    margin-bottom: 0;
  }
`

export default index
